/**
 * Used to map a key to a human readable name for includes.
 * Originally found in club.js
 * @param {string} id
 * @returns string
 */
export const includeName = (id) => {
  switch (id) {
    case 'gym': return 'Gymträning'
    case 'bath': return 'Bad'
    case 'group': return 'Gruppträning'
    case 'hiit': return 'STC HIIT'
    case 'theTrip': return 'Immersive The Trip'
    case 'arctrainer': return 'Arc Trainer'
    case 'babyStroller': return 'Barnvagn på gymmet'
    case 'bicycle': return 'Cyklar'
    case 'childcare': return 'Barnpassning'
    case 'coffeeLounge': return 'Coffee lounge'
    case 'crosscage': return 'CrossCage'
    case 'crosstrainer': return 'Crosstrainer'
    case 'girlsOnly': return 'Girls Only'
    case 'freeParking': return 'Fri parkering'
    case 'freeWeights': return 'Fria vikter'
    case 'functionalSurface': return 'Funktionell yta'
    case 'kidsClub': return 'Kids Club'
    case 'kidsDance': return 'Barndans'
    case 'lifestyleProgram': return 'STC Livsstilsprogram'
    case 'massageChair': return 'Massagestol'
    case 'outsideTraining':return 'Utomhusträning'
    case 'personalTrainer': return 'Personlig tränare'
    case 'rehab': return 'Rehab'
    case 'rower': return 'Rodd'
    case 'sauna': return 'Bastu'
    case 'shower': return 'Dusch'
    case 'skierg': return 'Skierg'
    case 'solarium': return 'Solarium'
    case 'stepper': return 'Trappmaskin'
    case 'treadmill': return 'Löpband'
    case 'virtualTraining': return 'Virtuell träning'
    case 'waterMassage': return 'Vattenmassage'
    case 'wattbike': return 'Wattbike'
    case 'wifi': return 'Wi-Fi'
  }
  return id
}

/**
 * Returns an image that corresponds with the associated includes key.
 * Originally found in club.js
 * @param {{ id: string, icon: string }} param0
 * @returns JSXElement
 */
export const IncludeIcon = ({ id, icon = '', ...rest }) => {
  switch (id) {
    case 'gym': icon = 'icon-gym'; break
    case 'group': icon = 'icon-group'; break
    case 'bath': icon = 'icon-bath'; break
    case 'hiit': icon = 'icon-hiit'; break
    case 'theTrip': icon = 'icon-the-trip'; break
    case 'arctrainer': icon = 'icon-arctrainer'; break
    case 'babyStroller': icon = 'icon-baby-stroller'; break
    case 'bicycle': icon = 'icon-bicycle'; break
    case 'childcare': icon = 'icon-childcare'; break
    case 'coffeeLounge': icon = 'icon-coffee-lounge'; break
    case 'crosscage': icon = 'icon-crosscage'; break
    case 'crosstrainer': icon = 'icon-crosstrainer'; break
    case 'girlsOnly': icon = 'icon-girls-only'; break
    case 'freeParking': icon = 'icon-free-parking'; break
    case 'freeWeights': icon = 'icon-free-weights'; break
    case 'functionalSurface': icon = 'icon-functional-surface'; break
    case 'kidsClub': icon = 'icon-kids-club'; break
    case 'lifestyleProgram': icon = 'icon-lifestyle'; break
    // case "kidsDance": icon = 'icon-gym'; break // Unclear why these are commented out.
    case 'massageChair': icon = 'icon-massage-chair'; break
    // case "outsideTraining": icon = 'icon-gym'; break // Unclear why these are commented out.
    case 'personalTrainer': icon = 'icon-personal-trainer'; break
    case 'rehab': icon = 'icon-rehab'; break
    case 'rower': icon = 'icon-rower'; break
    case 'sauna': icon = 'icon-sauna'; break
    case 'shower': icon = 'icon-shower'; break
    case 'skierg': icon = 'icon-skierg'; break
    case 'solarium': icon = 'icon-solarium'; break
    case 'stepper': icon = 'icon-stepper'; break
    case 'treadmill': icon = 'icon-treadmill'; break
    case 'virtualTraining': icon = 'icon-virtual-training'; break
    // case "waterMassage": icon = 'icon-gym'; break // Unclear why these are commented out.
    case 'wattbike': icon = 'icon-wattbike'; break
    case 'wifi': icon = 'icon-wifi'; break
  }
  return (
    <img
      src={icon ? `/images/${icon}.svg` : '/images/checkmark-circle.svg'}
      alt={`${includeName(id)}`}
      {...rest}
    />
  )
}



// WEBPACK FOOTER //
// ./helpers/includes.js